import type { SVGProps } from "react";

/** Rounded treasure-chest lid, metal bands and central clasp. */
export function TreasureChestIcon({
  size = 24,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M3 11V9a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v2M3 11h18v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />
      <path d="M7 5v6m10-6v6M7 12v8m10-8v8M3 16h4m10 0h4" />
      <rect
        x="10"
        y="10"
        width="4"
        height="5"
        rx="1"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}
